import './App.css';
import './App.Responsive.css';
import React, { useState } from 'react';
import Home from './views/Home';
import About from './views/About';
import Contact from './views/Contact';
import RAQ from './views/RAQ'
import Careers from './views/Careers';
import JobDescriptionPage from './jobs/JobDescriptionPage';
import ScrollToTop from './utils/ScrollToTop';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

const scrollToServicesSection = () => {
  const servicesSection = document.getElementById('services-section');
  if (servicesSection) {
    servicesSection.scrollIntoView({ behavior: 'smooth' });
  }
};

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Mobile menu
  const [isRAQOpen, setRAQOpen] = useState(false);

  const toggleRAQ = () => {
    setRAQOpen(!isRAQOpen);
  };

  const toggleMenu = () => {
      console.log('Clicked')
      setIsMenuOpen(prevState => !prevState);
  };

  const handleServicesClick = () => {
    // Execute the scroll after a delay to ensure the page has navigated
    setTimeout(scrollToServicesSection, 100);
  };

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <div className='TopBar'>
          <Link to="/">
              <img src='../assets/IMG_1188.png' alt='chambers electrical rva logo' />
          </Link>
          <div className="menu-icon" onClick={toggleMenu}>
            <span className="material-symbols-outlined">menu</span>
          </div>
          <nav className={`navigation ${isMenuOpen ? 'open' : ''}`}>
            <button className="close-btn" onClick={toggleMenu}><span className="material-symbols-outlined">close</span></button>
            <Link className='links' to="/">Home</Link>
            <Link className='links' to="/about">About</Link>
            <Link className='links' to="/" onClick={handleServicesClick} scrollToServicesSection={scrollToServicesSection}>Services</Link>
            <Link className='links' to="/contact">Contact</Link>
            <Link className='links' onClick={toggleRAQ}>Request a Quote</Link>
            <Link className='links' to="/careers">Careers</Link>
          </nav>
        </div>
        <RAQ isOpen={isRAQOpen} onToggleRAQ={toggleRAQ} />
        <Routes>
          <Route path="/" element={<Home onToggleRAQ={toggleRAQ}/>} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/job/:id" element={<JobDescriptionPage />} />
        </Routes>
      </Router>
      <footer className='Footer'>
        <div className="footer-content">
            <p>&copy; <span id="year">2023</span> Chambers Electrical and Communications. All Rights Reserved.</p>
            <p style={{ color: '#072447' }}>The data collected is for contact purposes only.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
